export enum LegalForm {
    SARL = 'sarl',
    EURL = 'eurl',
    SAS = 'sas',
    SASU = 'sasu',
    Micro = 'micro'
}